import { classNames } from "../../shared/utility";
import DatePickerInput from "../controls/DatePickerInput";

export default function DateRangeFilterDuos(props) {
  const {
    onChange,
    resetFilter,
    startDate,
    endDate,
    maxDate,
    hideTitle,
    showOneDate,
  } = props;

  return (
    <div className={hideTitle ? "" : "p-4"}>
      <div
        className={
          hideTitle ? "hidden" : "flex items-center justify-between gap-3"
        }
      >
        <p className="text-sm font-semibold text-[#0F172A]">Date Range</p>
        <button
          type="button"
          onClick={() => resetFilter()}
          className="text-xs font-semibold text-[#2563EB] hover:text-[#1D4ED8]"
        >
          Clear dates
        </button>
      </div>
      <div className="mt-2 flex gap-3">
        <DatePickerInput
          label="From:"
          name="startDate"
          onChange={(e) => onChange("startDate", e.target.value)}
          value={startDate}
          labelOn={true}
          maxDate={maxDate}
          type="text"
          dateFormat={"LLL dd, YYY"}
          labelDivClass="mb-0"
          labelClass="block text-sm font-medium text-[#0F172A]"
        />
        <div className={classNames(showOneDate ? "hidden" : null)}>
          <DatePickerInput
            label="To:"
            name="endDate"
            onChange={(e) => onChange("endDate", e.target.value)}
            minDate={startDate}
            maxDate={maxDate}
            value={endDate}
            labelOn={true}
            type="text"
            dateFormat={"LLL dd, YYY"}
            labelDivClass="mb-0"
            labelClass="block text-sm font-medium text-[#0F172A]"
          />
        </div>
      </div>
    </div>
  );
}
